import {EntityData, field, identifier} from "../resource/entity/entity.data";

export class FedeltaImageData extends EntityData<FedeltaImageData> {
    @identifier id: number;
    @field hash: string;

    // This is typically not available, but can be populated for a preview where the image is unsaved
    @field image: string;
}
